import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

export type AdminPageAction = 'features-refresh' | 'discord-bot-refresh';

@Injectable({
  providedIn: 'root'
})
export class AdminPageActionsService {
  private readonly actionsSubject = new Subject<AdminPageAction>();

  readonly actions$ = this.actionsSubject.asObservable();

  emit(action: AdminPageAction): void {
    this.actionsSubject.next(action);
  }
}
